import { cn } from "@/lib/utils";

interface ContainerProps {
  children: React.ReactNode;
  className?: string;
  /** "default" = max-w-7xl | "narrow" = max-w-4xl | "wide" = max-w-screen-2xl | "full" = no max */
  size?: "default" | "narrow" | "wide" | "full";
}

const sizeMap = {
  default: "max-w-7xl",
  narrow:  "max-w-4xl",
  wide:    "max-w-screen-2xl",
  full:    "",
};

export default function Container({
  children,
  className,
  size = "default",
}: ContainerProps) {
  return (
    <div className={cn("mx-auto w-full px-4 sm:px-6 lg:px-8", sizeMap[size], className)}>
      {children}
    </div>
  );
}
